export default __webpack_public_path__ + "static/yt-poster-01-0027a3e748506a82fb9cb703cfb495d1.jpeg";